import React, { Dispatch, SetStateAction } from 'react';

import { Select } from 'design-system';
import { pushGtmEvent } from 'analytics/gtm';

import { filterProvider } from '../../providers';

import { Container } from './styles';

type PeriodFilterProps = {
  dataValue: number;
  setDataValue: Dispatch<SetStateAction<number>>;
};

const PeriodFilter: React.FC<PeriodFilterProps> = ({
  dataValue,
  setDataValue,
}) => {
  return (
    <Container>
      <Select
        size="sm"
        value={dataValue}
        onChange={(event) => {
          const num = Number(event?.currentTarget?.value);
          const label =
            filterProvider.find((f) => f.value === num)?.label || String(num);
          pushGtmEvent({
            event: 'click_cta',
            eventCategory: 'home',
            eventAction: 'click',
            eventLabel: label,
            pageSection: 'home',
            elementType: 'button',
          });
          setDataValue(num);
        }}
      >
        {filterProvider.map((filter) => (
          <option key={filter.value} value={filter.value}>
            {filter.label}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default PeriodFilter;
